import { styled } from '@mui/system'
import { Box, Tooltip } from '@material-ui/core'
import './scss/colors.scss'
import { customColor } from './globalComponent'
import { createTheme, withStyles } from '@material-ui/core/styles'
export const theme = createTheme({})

export const Customprogressbar = styled(Box)({
    '& > .MuiBox-root': {
        display: 'flex',
        '.MuiBox-root': {
            '&:first-child': {
                borderRadius: '5px 0 0 5px'
            },
            '&:nth-child(2)': {},
            '&:nth-child(3)': {
                borderRadius: '0 5px 5px 0'
            },
            height: 24,
            padding: '5px',
            color: customColor.White,
            textAlign: 'center',
            fontWeight: 700,
            fontSize: 16,
            fontFamily: '"Lato", sans-serif !important',
            flexGrow: 1,
            [theme.breakpoints.down('md')]: {
                height: 16,
            },
        }
    }
})

export const LightTooltip = withStyles(theme => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 11,
        width: 500,
        padding: '20px'
    }
}))(Tooltip)

export const Colorindicator = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    '& .MuiBox-root': {
        display: 'flex',
        alignItems: 'center'
    }
})

export const Cidot = styled('span')(({ bgcolor }) => ({
    backgroundColor: bgcolor,
    width: 15,
    height: 15,
    borderRadius: '50%',
    marginRight: 8
}))

export const Citext = styled('span')({
    fontSize: '14px !important',
    fontWeight: '400 !important',
    color: customColor.Gray
})

export const Resultbox = styled(Box)({
    '& .MuiAccordion-root': {
        '&:first-child': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #0722b6'
            }
        },
        '&:nth-child(2)': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #03989e'
            }
        },
        '&:nth-child(3)': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #07d034'
            }
        },
        '&:nth-child(4)': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #fa6c51'
            }
        },
        '&:nth-child(5)': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #b304a1'
            }
        },
        '&:nth-child(6)': {
            '& .MuiAccordionSummary-root': {
                borderLeft: '6px solid #6cbf84'
            }
        },
        '.MuiAccordionDetails-root': {
            padding: 0
        }
    },

    '.MuiAccordionSummary-root': {
        padding: '15px 20px',
        [theme.breakpoints.down('md')]: {
            padding: '15px 60px 15px 15px'
        },
        [theme.breakpoints.down('md')]: {
            padding: '0px 60px 0px 15px'
        },
    },
    h4: {
        fontSize: 18,
        fontWeight: 500,
        marginBottom: 5,
        lineHeight: 'normal',
        color: customColor.Black,
        [theme.breakpoints.down('md')]: {
            fontSize: 16,
        },
    },
    h5: {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: 'normal',
        color: customColor.Gray,
        [theme.breakpoints.down('md')]: {
            fontSize: 16,
        },
    },
    '& .MuiAccordionDetails-root': {
        h4: {
            color: customColor.DarkGrey,
            fontSize: 18,
            fontWeight: 500,
            textIndent: '-18px',
            marginLeft: '18px',
            [theme.breakpoints.down('md')]: {
                fontSize: 16,
                marginLeft: 0,
            },
        }
    },
    '& .MuiAccordionSummary-expandIcon': {
        position: 'absolute',
        right: 20
    }
})

export const Resultboxheading = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    backgroundColor: customColor.White,
    padding: '10px 20px',
    borderRadius: '5px 5px 0 0',
    border: '1px solid #d7d7d7',
    [theme.breakpoints.down('xs')]: {
        display: 'none'
    },
    h5: {
        fontWeight: 500,
        fontSize: 16,
        lineHeight: 'normal',
        [theme.breakpoints.down('md')]: {
            fontSize: '14px !important',
        },
    }
})

export const Enquestionlist = styled(Box)({
    flexGrow: 1,
    [theme.breakpoints.down('md')]: {
        padding: '0 15px',
    },
})

export const Enquestion = styled(Box)({
    padding: '25px 0px',
    borderTop: '1px solid #e5e5e5',
    [theme.breakpoints.down('md')]: {
        padding: '15px 0px',
    },
    h4: {
        paddingLeft: 20
    }
})

export const ProgressPercent = styled('span')({
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: 'normal',
    color: customColor.Black,
    [theme.breakpoints.down('md')]: {
        fontSize: 15,
    },
})
